// function searchVendors () {
//   const filter = document.getElementById('search-vendors-input').value
//   const ul = document.getElementById('vendors-home-list')
//   const li = ul.getElementsByTagName('li')
//   for (let i = 0; i < li.length; i++) {
//     const elemText = li[i].getElementsByTagName('a')[0].text
//     li[i].style.display = !filter || elemText.toUpperCase().includes(filter.toUpperCase()) ? '' : 'none'
//   }
// }

// const searchVendorInput = $('#search-vendors-input')

// searchVendorInput.focusin(function () {
//   $('#vendors-home-list').fadeIn('fast')
// })
// searchVendorInput.focusout(function () {
//   $('#vendors-home-list').fadeOut(1000)
// })
// searchVendorInput.on('keyup', function () { searchVendors() })

$('.home-banners-mob-slider').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 5000,
      settings: 'unslick'
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
})

// $('.home_list_col .product_list_slider').slick({
//   dots: false,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 2,
//   slidesToScroll: 2,
//   autoplay: false,
//   responsive: [
//     {
//       breakpoint: 1200,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 992,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 400,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// })
//
// $('.offers_list_wrapper .product_list_slider').slick({
//   dots: false,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 4,
//   slidesToScroll: 4,
//   autoplay: true,
//   autoplaySpeed: 5000,
//   responsive: [
//     {
//       breakpoint: 1200,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3
//       }
//     },
//     {
//       breakpoint: 992,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 450,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// })

// $('.three-col-slider').slick({
//   dots: true,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 3,
//   slidesToScroll: 3,
//   responsive: [
//     {
//       breakpoint: 3000,
//       settings: 'unslick'
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// })
// $('.gridslidemain').slick({
//   arrows: true,
//   infinite: false,
//   speed: 1500,
//   slidesToShow: 1,
//   slidesToScroll: 1
// })

// $('.home-banners-mob-slider').slick({
//   dots: true,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 3,
//   slidesToScroll: 3,
//   responsive: [
//     {
//       breakpoint: 5000,
//       settings: 'unslick'
//     },
//     {
//       breakpoint: 576,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// })

$('.three-col-slider').slick({
  dots: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 5000,
      settings: 'unslick'
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000
      }
    }
  ]
})
$('.gridSliderMobile').slick({
  dots: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  infinite: true,
  centerMode: true,
  centerPadding: '20px',
  responsive: [
    {
      breakpoint: 5000,
      settings: 'unslick'
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 360,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
})

$('.slider-wrapper-flex').slick({
  dots: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true
      }
    }
  ]
})

$('.single_slider').slick({
  fade: true,
  cssEase: 'linear'
})

// $('.home_product_slider_col .product_list_slider').slick({
//   dots: false,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 3,
//   slidesToScroll: 3,
//   autoplay: true,
//   autoplaySpeed: 5000,
//   responsive: [
//     {
//       breakpoint: 1200,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3
//       }
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 400,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// })
//
// $('.single_prodlist_slider .product_list_slider').slick({
//   dots: false,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 5,
//   slidesToScroll: 5,
//   autoplay: true,
//   autoplaySpeed: 5000,
//   responsive: [
//     {
//       breakpoint: 1200,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3
//       }
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 400,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// })

$('.vendors-home-slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 8,
  slidesToScroll: 8,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 7,
        slidesToScroll: 7
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 6
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }
  ]
})

$('.usp-slider-mobile').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 5000,
      settings: 'unslick'
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
})

// $('.home-tabs-prod-slider').slick({
//   dots: false,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 4,
//   slidesToScroll: 4,
//   responsive: [
//     {
//       breakpoint: 1200,
//       settings: {
//         dots: true,
//         slidesToShow: 4,
//         slidesToScroll: 4
//       }
//     },
//     {
//       breakpoint: 1024,
//       settings: {
//         dots: true,
//         slidesToShow: 3,
//         slidesToScroll: 3
//       }
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         dots: true,
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 400,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// })

$('.offer_countdown_row [data-countdown]').each(function () {
  const $this = $(this)
  const finalDate = $(this).data('countdown')
  $this.countdown(finalDate, function (event) {
    $this.html(event.strftime('<span class="offers_time">%H<span class="countdown_info">Hours</span></span><span class="offers_time">%M<span class="countdown_info">Mins</span></span><span  class="offers_time">%S<span class="countdown_info">Secs</span></span>'))
  })
})
